import { Body, Button, colors, Image, Spacer } from '@spritz-finance/ui'
import { useNavigate } from 'react-router-dom'
import { Column } from '../../../../components/Layout/Column'
import { ThemedHeroImage } from '../../../../components/ThemedHeroImage'

export const NoTransferHistory = () => {
    const navigate = useNavigate()
    return (
        <Column align="center">
            <Spacer height={48} />
            <Body.SmBold size={14} secondary>
                No completed transfers yet
            </Body.SmBold>
            <Spacer height={8} />
            <Body.SmBold size={14} color={colors.medGrey}>
                Once a transfer settles in your account, it will show up here
            </Body.SmBold>
            <Spacer height={48} />
            <ThemedHeroImage>
                <Image.BillHistory width={300} />
            </ThemedHeroImage>
            <Spacer height={48} />
            <Button.CTA onClick={() => navigate('/offramp')}>Go to accounts</Button.CTA>
        </Column>
    )
}
